import { Injectable } from '@angular/core';

import { LabelPlacement } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class LabelPlacementService extends TmsWebBaseEditService<LabelPlacement, LabelPlacement> {
  constructor() {
    super('LabelPlacement', $localize`Label Placement`);
  }
}
